import useAuth from "../../../hooks/useAuth"
import { useFetchUserDataQuery } from "../../../app/userApiSlice"
import ViewUserCard from "../components/ViewUserCard"

const UserDashboard = () => {
  const { uid } = useAuth()
  const { data } = useFetchUserDataQuery(uid)

  return (
    <div className="w-100">
      <h3 className="mb-4 fw-bold">Profile</h3>

      <ViewUserCard data={data} />
    </div>
  )
}

export default UserDashboard
